import { createApp } from "vue";
import App from "./App.vue";

import "@fontsource/poppins/300.css";
import "@fontsource/poppins/400.css";
import "@fontsource/poppins/500.css";
import "@fontsource/poppins/600.css";
import "@fontsource/poppins/700.css";
import VueGtag from "vue-gtag";

createApp(App)
  .use(VueGtag, {
    config: { id: "UA-164018774-1" },
    enabled: process.env.NODE_ENV !== "development",
  })
  .mount("#app");
